export class WebhookV1StandardPayloadResource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadResourceTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadResourceArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadResource.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadResourceTypeEnum;
(function (WebhookV1StandardPayloadResourceTypeEnum) {
    WebhookV1StandardPayloadResourceTypeEnum["RansomwareDetectedInResource"] = "RANSOMWARE_DETECTED_IN_RESOURCE";
    WebhookV1StandardPayloadResourceTypeEnum["RansomwareInfectionRemediated"] = "RANSOMWARE_INFECTION_REMEDIATED";
    WebhookV1StandardPayloadResourceTypeEnum["ResourceExcludedFromRansomwareDetection"] = "RESOURCE_EXCLUDED_FROM_RANSOMWARE_DETECTION";
    WebhookV1StandardPayloadResourceTypeEnum["RansomwareDetectionExclusionCanceled"] = "RANSOMWARE_DETECTION_EXCLUSION_CANCELED";
    WebhookV1StandardPayloadResourceTypeEnum["MalwareRemediated"] = "MALWARE_REMEDIATED";
    WebhookV1StandardPayloadResourceTypeEnum["DataAnomalyRemediated"] = "DATA_ANOMALY_REMEDIATED";
    WebhookV1StandardPayloadResourceTypeEnum["AiDataRiskRemediated"] = "AI_DATA_RISK_REMEDIATED";
    WebhookV1StandardPayloadResourceTypeEnum["DataExposureRiskRemediated"] = "DATA_EXPOSURE_RISK_REMEDIATED";
})(WebhookV1StandardPayloadResourceTypeEnum || (WebhookV1StandardPayloadResourceTypeEnum = {}));
